<template>
  <div
    v-if="movimientoPartida != null"
    class="div-contenidoPCRecuperarMercanciaVolcadaVistaPartida"
  >
    <!-- Cabecera del detalle -->
    <f7-row>
      <f7-col width="20">
        <div class="div-horaRegistroMovimiento">
          {{ ProcesarHora(movimientoPartida.FechaInicio) }}
        </div>
      </f7-col>
      <f7-col width="60">
        <span
          class="span-numeroPartidaVistaPartida"
        >
          {{ `${$t('common.batch').toUpperCase()} ${movimientoPartida.Serie ?? ''}/${movimientoPartida.Partida.Numero}` }}
        </span>
        <br>
        <span
          v-if="movimientoPartida.DatosOrigen != null && movimientoPartida.DatosOrigen.length > 0"
          class="span-texto-gris-1"
        >
          {{ `${$t('common.originBatch').toUpperCase()}: ${ObtenerCadenaNumerosPartidas(movimientoPartida.DatosOrigen)}` }}
        </span>
      </f7-col>
      <f7-col width="20">
        <span
          class="btn-oval-azulOscuro-26  seleccionable btn-informacionDatosOrigen"
          @click="AbrirDatosOrigenPale()"
        >
          {{ $t('production.dump.retrieve.view.batch.header.originData') }}
        </span>
      </f7-col>
    </f7-row>
    <!-- Información detalle -->
    <div class="div-informacionDelDetalle">
      <f7-row>
        <f7-col width="40">
          <span class="span-ttlElemento">
            {{ $t('production.dump.retrieve.view.batch.info.merchandise') }}
          </span>
        </f7-col>
        <f7-col width="60">
          <span class="span-textoElemento"> {{ movimientoPartida.DescripcionArticulo }} </span>
        </f7-col>
      </f7-row>
      <f7-row v-if="usoLotesMovilidad && movimientoPartida.Lote != null">
        <f7-col width="40">
          <span class="span-ttlElemento">
            {{ $t('common.lot') }}

          </span>
        </f7-col>
        <f7-col width="60">
          <span class="span-textoElemento"> {{ movimientoPartida.Lote.Codigo }}</span>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="40">
          <span class="span-ttlElemento">
            {{ $t('common.pallet') }}

          </span>
        </f7-col>
        <f7-col width="60">
          <span class="span-textoElemento"> {{ movimientoPartida.NumeroSerie }} </span>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="40">
          <span class="span-ttlElemento">

            {{ $t('production.dump.retrieve.view.batch.info.packages') }}

          </span>
        </f7-col>
        <f7-col width="60">
          <span class="span-textoElemento"> {{ movimientoPartida.CantidadEnvases }} </span>
        </f7-col>
      </f7-row>
      <f7-row v-if="movimientoPartida.CantidadEnvases > 0">
        <f7-col width="40">
          <span class="span-ttlElemento">

            {{ $t('production.dump.retrieve.view.batch.info.netWeight') }}
          </span>
        </f7-col>
        <f7-col width="60">
          <span class="span-textoElemento"> {{ movimientoPartida.Cantidad }} </span> <!-- En una cola de volcado en cantidad siempre se guaran kilos -->
        </f7-col>
      </f7-row>
      <f7-row v-if="registrarDestrioEnVolcado && movimientoPartida.ArticuloNumeroSerieDestrio != null">
        <f7-col width="40">
          <span class="span-ttlElemento">
            {{ $t('production.dump.retrieve.view.batch.info.scrapPallet') }}
          </span>
        </f7-col>
        <f7-col width="20">
          <span class="span-textoElemento"> {{ movimientoPartida.ArticuloNumeroSerieDestrio.NumeroSerie }} </span>
        </f7-col>
        <f7-col width="20">
          <span class="span-ttlElemento">
            {{ $t('common.quantity') }}
          </span>
        </f7-col>
        <f7-col width="15">
          <span class="span-textoElemento"> {{ movimientoPartida.CantidadDestrio }} </span>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="40">
          <span class="span-ttlElemento">
            {{ $t('production.dump.retrieve.view.batch.info.printLabel') }}
          </span>
        </f7-col>
        <f7-col width="60">
          <input
            type="checkbox"
            :value="imprimirEtiquetaRecuperadoVolcadoLocal"
            :checked="imprimirEtiquetaRecuperadoVolcadoLocal"
            @change="imprimirEtiquetaRecuperadoVolcadoLocal = !imprimirEtiquetaRecuperadoVolcadoLocal"
          >
        </f7-col>
      </f7-row>
    </div> <!-- div-informacionDelDetalle -->

    <!-- Botones de volcado y recuperado -->
    <f7-row
      v-if="movimientoPartida.CantidadEnvases > 0"
      class="div-row-botonesDeVolcadoYRecuperado"
    >
      <f7-col
        :width="mostrarOpcionesDeVolcadoRecuperadoParcial ? 50 : 100"
      >
        <f7-button
          id="btn-recuperarTodo"
          fill
          class="btn-color-oscuro-1 btn-tamaño-3"
          @click="RecuperadoTotalMercancia()"
        >
          {{ $t('production.dump.retrieve.view.batch.buttons.retrieveEverythingText') }}
        </f7-button>
      </f7-col>
      <f7-col
        v-if="mostrarOpcionesDeVolcadoRecuperadoParcial"
        :width="mostrarOpcionesDeVolcadoRecuperadoParcial ? 50 : 100"
      >
        <f7-button
          fill
          class="btn-color-amarillo-1 btn-tamaño-3"
          @click="PrepararRecuperadoParcial()"
        >
          {{ $t('production.dump.retrieve.view.batch.buttons.partialRetrievalText') }}
        </f7-button>
      </f7-col>
    </f7-row>

    <f7-row
      v-if="registrarDestrioEnVolcado"
      class="div-row-botonesDeVolcadoYRecuperado"
    >
      <f7-col width="100">
        <f7-button
          id="btn-registrarDestrio"
          fill
          class="btn-tamaño-3"
          @click="RegistrarDestrio()"
        >
          {{ $t('production.dump.retrieve.view.batch.buttons.registerScrapText') }}
        </f7-button>
      </f7-col>
    </f7-row>

    <!-- Action para recuperado parcial -->
    <f7-actions
      class="actions-1"
      :opened="actionsRecuperadoParcial"
      @actions:closed="CerrarActionDetalle()"
    >
      <div class="div-actionsTitulo-2">
        <span class="padding-left">
          {{ $t('production.dump.retrieve.view.batch.partialRetrievalActions.title').toUpperCase() }}
        </span>
      </div>

      <UCUnidadMedidaKiloYEnvase
        :activo="activo"
        :default-envases="cantidadMaximaEnvasesRecuperar"
        :default-kilos="cantidadMaximaKilosRecuperar"
        :autocalculo="true"
        plantilla="P2"
        modo-auto-calculo="PROPORCIONES"
        @cantidad-envases-y-kilos-modificada="EventCantidadesModificadas"
      />

      <!-- Separador -->
      <div class="div-elementoSeparador-90" />
      <!-- Pie de  Boton Opciones busqueda -->
      <div class="div-opcionesActions">
        <f7-row>
          <f7-col
            width="50"
            class="col-izquierdaActions"
          >
            <a
              class="link link-izquierdaActions-1"
              @click="CerrarActionDetalle()"
            >
              {{ $t('common.cancel').toUpperCase() }}
            </a>
          </f7-col>
          <f7-col
            width="50"
            class="col-derechaActions"
          >
            <a
              class="link link-derechaActions-1"
              @click="RecuperadoParcialMercancia()"
            >
              {{ $t('common.retrieve').toUpperCase() }}
            </a>
          </f7-col>
        </f7-row>
      </div>
    </f7-actions>

    <!-- popup-DatosOrigenPale -->
    <f7-popup
      class="popup-DatosOrigenPale"
      :opened="popupDatosOrigenPale"
      @popup:closed="popupDatosOrigenPale = false"
    >
      <f7-navbar
        :title="$t('production.dump.logisticUnit.originPalletDataPopup.title')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupDatosOrigenPale = false">
            {{ $t('common.x') }}
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div>
        <PCDatosOrigenUnidadLogistica :activo="popupDatosOrigenPale" />
      </div>
    </f7-popup>
  </div> <!-- div-contenidoPCRecuperarMercanciaVolcadaVistaPartida -->
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus'; // Import the EventBus.
import ConexionTA from '@/js/services/traceability/APITraceability';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import PCDatosOrigenUnidadLogistica from '@/components/production/traceability/PCDatosOrigenUnidadLogistica.vue';
import UCUnidadMedidaKiloYEnvase from '@/components/common/UCUnitMeasureKiloAndContainer.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'PCRecuperarMercanciaVolcadaVistaPartida',
  components: {
    UCUnidadMedidaKiloYEnvase,
    PCDatosOrigenUnidadLogistica,
  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    idPartida: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      movimientoPartida: null,
      actionsRecuperadoParcial: false,
      cantidadMaximaEnvasesRecuperar: 0,
      cantidadMaximaKilosRecuperar: 0,
      cantidadEnvasesRecuperar: 0,
      cantidadKilosRecuperar: 0,
      popupDatosOrigenPale: false,
      imprimirEtiquetaRecuperadoVolcadoLocal: false,
      imprimirEtiquetaRecuperadoVolcado: useParamRef('ImprimirEtiquetaRecuperadoVolcado'),
      registrarDestrioEnVolcado: useParamRef('RegistrarDestrioEnVolcado'),
      usoLotesMovilidad: useParamRef('UsoLotesMovilidad'),
      trabajarConNumerosDeSerie: useParamRef('trabajarConNumerosDeSerie'),
      actualizarLineasNumeroSerieVolcado: useParamRef('ActualizarLineasNumeroSerieVolcado'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDeVolcadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'unidadLogisticaSeleccionada',
      'partidaSeleccionada',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-orange)',
        '--f7-navbar-text-color': '#fff',
      };
    },
    mostrarOpcionesDeVolcadoRecuperadoParcial() {
      return (this.trabajarConNumerosDeSerie && this.actualizarLineasNumeroSerieVolcado) || (!this.trabajarConNumerosDeSerie);
    },
  },

  watch: {
    imprimirEtiquetaRecuperadoVolcado(val) {
      this.imprimirEtiquetaRecuperadoVolcadoLocal = val;
    },
  },

  created() {
    // this.establecerMododDeFrm();
    this.InicializarFrm();

    this.CargarElementosRecuperablesPartida();
  },

  methods: {
    InicializarFrm() {
      Log(this, this.InicializarFrm.name);
      this.imprimirEtiquetaRecuperadoVolcadoLocal = this.imprimirEtiquetaRecuperadoVolcado; // Solo se permiten si en el WebConfig esta configurado este parametro.
    },

    /** Método cargarElementosRecuperablesPartida */
    CargarElementosRecuperablesPartida() {
      Log(this, this.CargarElementosRecuperablesPartida.name);
      const self = this;
      if (this.idPartida === 0) {
        return;
      }
      HiDialog.Preloader(true, this.$t('production.dump.retrieve.view.batch.get.preloaderText'));

      const puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
      const objAnsSeleccionado = this.unidadLogisticaSeleccionada;

      ConexionTA.callObtenerElementosRecuperablesDeUnaPartida(
        puntoDeVolcado.Id,
        this.idPartida,
        objAnsSeleccionado.NumeroSerie,
      ).then((result) => {
        if (result.Valor) {
          self.ProcesarRespuestaElementosRecuperablesPartida(JSON.parse(result.Mensaje));
          HiDialog.Preloader(false);
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        });
    },
    /**
     * La partida puede estar volcada de diferentes ArticulosNumerosSerie por lo que si,
     * la busqueda se realiza desde un volcado tendremos el ID de volcado que identifica la UL correspondiente y solo nos quedamos con ella.
     */
    ProcesarRespuestaElementosRecuperablesPartida(respuesta) {
      Log(this, this.ProcesarRespuestaElementosRecuperablesPartida.name);
      const objAnsSeleccionado = this.unidadLogisticaSeleccionada;
      if (objAnsSeleccionado == null) {
        [this.movimientoPartida] = respuesta;
      } else {
        [this.movimientoPartida] = respuesta.filter((volcado) => volcado.IdUnidadLogistica === objAnsSeleccionado.Id);
      }
    },

    ProcesarHora(fechaYHora) {
      return SoporteFechaYHora.obtenerHorasYMinutos(fechaYHora);
    },

    CerrarActionDetalle() {
      Log(this, this.CerrarActionDetalle.name);
      this.actionsRecuperadoParcial = false;
    },

    PrepararRecuperadoParcial() {
      Log(this, this.PrepararRecuperadoParcial.name);
      this.actionsRecuperadoParcial = true;
      this.cantidadMaximaKilosRecuperar = this.movimientoPartida.Cantidad;
      this.cantidadMaximaEnvasesRecuperar = this.movimientoPartida.CantidadEnvases;
    },

    NotificarMovimientoRealizado() {
      Log(this, this.NotificarMovimientoRealizado.name);
      eventBus.emit('PCRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado'); // Llama al resto de componentes para su actualización.
    },

    EventCantidadesModificadas(objCantidades) {
      Log(this, this.EventCantidadesModificadas.name);
      if (objCantidades == null) {
        return;
      }
      this.EstablecerCantidadDesDeRecuperadoParcial(objCantidades.CantidadKilosModificado, objCantidades.CantidadEnvasesModificado);
    },

    EstablecerCantidadDesDeRecuperadoParcial(cantidadKilos, cantidadEnvases) {
      Log(this, this.EstablecerCantidadDesDeRecuperadoParcial.name);
      this.cantidadEnvasesRecuperar = cantidadEnvases;
      this.cantidadKilosRecuperar = cantidadKilos;
    },

    RecuperadoParcialMercancia() {
      Log(this, this.RecuperadoParcialMercancia.name);
      this.actionsRecuperadoParcial = false;
      this.RecuperadoDeMercancia();
    },

    RecuperadoTotalMercancia() {
      Log(this, this.RecuperadoTotalMercancia.name);
      this.cantidadEnvasesRecuperar = this.movimientoPartida.CantidadEnvases;
      this.cantidadKilosRecuperar = this.movimientoPartida.Cantidad;
      this.RecuperadoDeMercancia();
    },

    RecuperadoDeMercancia() {
      Log(this, this.RecuperadoDeMercancia.name);
      if (!this.ValidacionesRecuperado()) {
        return;
      }
      const self = this;
      const lineaDeProduccion = this.lineaDeProduccionSeleccionada;
      const puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
      HiDialog.Preloader(true, this.$t('production.dump.retrieve.view.batch.retrieveDump.preloaderText'));
      ConexionTA.callRecuperarMercanciaVolcada(lineaDeProduccion.Id, puntoDeVolcado.Id, this.movimientoPartida.Partida.Id, this.movimientoPartida.NumeroSerie, this.movimientoPartida.Id, this.cantidadEnvasesRecuperar, this.cantidadKilosRecuperar).then((result) => {
        if (result.Valor) {
          HiDialog.Preloader(false);
          HiNotification.Toast(this.$t('production.dump.retrieve.view.batch.retrieveDump.successToastText'));
          self.ImprimirEtiquetaRecuperado();
          self.NotificarMovimientoRealizado();
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        });
    },
    ValidacionesRecuperado() {
      Log(this, this.ValidacionesRecuperado.name);
      this.cantidadMaximaEnvasesRecuperar = this.movimientoPartida.CantidadEnvases;
      if (this.cantidadEnvasesRecuperar > this.cantidadMaximaEnvasesRecuperar) {
        HiNotification.Toast(this.$t('production.dump.retrieve.view.batch.retrieveDump.maxPackagesToastText'));
        return false;
      }
      return true;
    },

    AbrirDatosOrigenPale() {
      Log(this, this.AbrirDatosOrigenPale.name);
      this.unidadLogisticaSeleccionada = {
        Id: this.movimientoPartida.IdUnidadLogistica,
        NumeroSerie: this.movimientoPartida.NumeroSerie,
      };
      this.popupDatosOrigenPale = true;
    },

    ObtenerCadenaNumerosPartidas(lstPartidas) {
      Log(this, this.ObtenerCadenaNumerosPartidas.name);
      let cadenaPartidas = '';
      try {
        lstPartidas.forEach((p) => {
          const seriePartida = p.Partida.Serie != null ? p.Partida.Serie : '';
          cadenaPartidas += `${seriePartida}/${p.Partida.Numero}, `;
        });
        cadenaPartidas = cadenaPartidas.slice(0, -2); // Quitamos el último carácter.
      } catch (error) {
        LogError(error);
      }
      return cadenaPartidas;
    },

    RegistrarDestrio() {
      Log(this, this.RegistrarDestrio.name);
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/FrmGenerateDumpDiscardsPallet');
      const partidaActiva = this.partidaSeleccionada; //
      this.partidaSeleccionada = partidaActiva; // Reasignamos el valor para afianzarlo en la recarga de los valores de la pagina cuando se genera un destrio.
    },

    ImprimirEtiquetaRecuperado() {
      if (!this.imprimirEtiquetaRecuperadoVolcadoLocal) {
        return;
      }
      const self = this;
      const puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
      const unidadLogistica = this.unidadLogisticaSeleccionada;
      ConexionTA.callImprimirRecuperacionVolcadoUL(unidadLogistica.Id, puntoDeVolcado.Id).then((result) => {
        if (result.Valor) {
          Log(self.volcados);
          HiDialog.Preloader(false);
          HiNotification.Toast(this.$t('production.dump.retrieve.view.batch.print.successToastText'));
        } else {
          LogError('error en impresion de etiqueta recuperada');
        }
      })
        .catch((error) => {
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        });
    },

  },
};
</script>

<style scoped lang="scss">
/*** Nuevos Estilos **/
.div-horaRegistroMovimiento {
  background: rgb(0 155 166 / 10%);
  border: 1px solid #009ba6;
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #009ba6;
  font-size: 14px;
  min-height: 25px;
  max-width: 100px;
}

.span-numeroPartidaVistaPartida {
  color: var(--his-darkgray);
  font-size: 18px;
}

.div-contenidoPCRecuperarMercanciaVolcadaVistaPartida {
  margin-top: 65px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
}

.span-ttlElemento {
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
}

.span-textoElemento {
  color: #009ba6;
  font-size: 14px;
  font-weight: 500;
}

.div-informacionDelDetalle {
  margin-top: 21px;
}

.row {
  padding-right: 15px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
}

.div-componenteUCUnidadMedidaKiloYEnvase {
  /* margin-right: 18px; */
  // margin-top: 18px;
  margin-left: 15px;
  margin-bottom: 18px;
}

.div-row-botonesDeVolcadoYRecuperado {
  margin-top: 15px;
}

.actions-recuperadoParcial {
  background-color: var(--his-tierra-white);
}

.btn-oval-azulOscuro-26 {
  background-color: var(--his-steel-blue);
  color: #fff;
  border-radius: 100%;
  width: 26px;
  height: 26px;
  min-height: 26px;
  min-width: 26px;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-informacionDatosOrigen {
  display: flex;
  float: right;
}

.btn-color-oscuro-1 {
  background-color: var(--his-darkgray) !important;
  box-shadow: 0 8px 15px 0 rgb(74 74 74 / 10%);
}

.btn-color-amarillo-1 {
  background-color: var(--his-orange) !important;
  box-shadow: 0 8px 15px 0 rgb(245 166 35 / 15%);
}

.btn-tamaño-3 {
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.actions-1 {
  background-color: var(--his-tierra-white) !important;
}

.div-tituloActions-1 {
  margin-top: 15px;
  margin-left: 15px;
}

.span-tituloActions-1 {
  color: var(--his-ash-gray);
  font-size: 14px;
}

.div-opcionesActions {
  padding-right: 18px;
  padding-left: 18px;
  padding-top: 13px;
}

.link-izquierdaActions-1 {
  color: var(--his-tomate) !important;
  font-size: 14px;
}

.link-derechaActions-1 {
  color: #009ba6 !important;
  font-size: 18px;
  font-weight: 500;
}
</style>
